// ** React Imports
import React, {
    useState } from 'react'

// ** MUI Imports
import { ArrowRight, Export } from 'mdi-material-ui';

// ** Utils and Child Imports
import FormDialog from './ExportDialogComponent';
import { ExportOptionConfigType } from 'src/lib/types/exports';
import { Button } from '@mui/material';
import FloGenericDialog from '../feedback-and-dialog/GenericDialog';


interface ExportComponentProps {
    isExportDisabled: boolean
    exportOptionData: ExportOptionConfigType[]
    titleText: string,
    jobButtonText: string,
    dialogButtonText: string,
    globalEndDate?: string | Date
    globalStartDate?: string | Date
    hideRadioButtons: boolean
}

const ExportComponent: React.FC<ExportComponentProps> = ({
    isExportDisabled, 
    exportOptionData,
    globalEndDate,
    globalStartDate,
    titleText,
    jobButtonText,
    dialogButtonText,
    hideRadioButtons=false
}) => {

    const [ isOpenFormDialog, setOpenFormDialog ] = useState<boolean>(false);

    return (
        <>       
            <Button
                id='export-button'
                variant='outlined'
                size='medium'
                disabled={isExportDisabled}
                style={{ whiteSpace: 'nowrap', height: 38, background: "#FFFFFF" }}
                onClick={() => setOpenFormDialog(true)}
                endIcon={<ArrowRight id='export-button-icon'/>}>
                {dialogButtonText}
            </Button>
             
            <FormDialog
                underInputText={"A download link will be sent to this email address."}
                emailInputLabel={"Send to"}
                emailInputPlaceholder={"Enter email address"}
                exportCategoryData={exportOptionData ?? []}
                isOpen={isOpenFormDialog}
                setIsDialogOpen={setOpenFormDialog}
                titleText={titleText}
                jobButtonColor={"primary"}
                jobButtonText={jobButtonText}
                cancelButtonColor={"secondary"}
                cancelButtonText={"Cancel"}
                startDateLabel={"Start date"}
                endDateLabel={"End date"}
                globalEndDate={globalEndDate}
                globalStartDate={globalStartDate}
                hideRadioButtons={hideRadioButtons}
                hideDateRange={false}
            />  
        </>
    )
}

export default ExportComponent;